// extracted by mini-css-extract-plugin
export default {"p_content":"e057f4aeac"};